
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../helper/api";
import { setCookies } from "../../helper/utils";
import { toast } from "react-toastify";

export const login = createAsyncThunk("user/login", async (payload) => {
  console.log('response', payload)
  const response = await api.post("admin/login", payload);
 
  return response;
});

const loginSlice = createSlice({
  name: "user",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        console.log(30)
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        console.log(34, action.payload)
        setCookies('token', action.payload.data.data.token)
        setCookies('role', action.payload.data.data.role)
        toast.success(action.payload.data.message);
        state.loading = false;
        state.data = action.payload.data.data;
        
      })
      .addCase(login.rejected, (state, action) => {
        // console.log(43, action, state)
        state.loading = false;
        state.error = action.error.message;
        // toast.error(action.error.message);
      });
  },
});

export default loginSlice.reducer;
